import { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import gql from 'graphql-tag';
import { ActionPayload, DataLakeDirectoryCreateRequestInput } from '../gql-types.generated';

// eslint-disable-next-line @typescript-eslint/naming-convention
const MUTATION_CREATE_DIRECTORY = gql`
    mutation createDataLakeDirectory ($input: DataLakeDirectoryCreateRequestInput!){
        createDataLakeDirectory(input: $input) {
            message
            errors {
                code
                message
            }
            result
            data
        }
    }
`;

export const MutationCreateDataLakeDirectory = async (
    client: ApolloClient<NormalizedCacheObject>,
    directoryInput: DataLakeDirectoryCreateRequestInput
    ): Promise<ActionPayload | undefined> => {
        const { 
            directoryName, 
            parentDirectoryPath,
        } = directoryInput as DataLakeDirectoryCreateRequestInput;
        const {data, errors } = await client.mutate<{createDataLakeDirectory: ActionPayload}>({
            variables: {
                input: {
                    directoryName, 
                    parentDirectoryPath 
                }
            },
            mutation: MUTATION_CREATE_DIRECTORY
        });
        if (errors && errors.length > 0) {
            errors.forEach(error => {
                // Log error details in the console
                console.error(error);
            });
            // Friendly error to active user
            throw new Error('An error has occurred trying to create the Data Lake directory.');
        }
        if (data && data.createDataLakeDirectory) {
            return data.createDataLakeDirectory;
        }
    
        return undefined;
    };